import {
  Box,
  Button,
  Field,
  Flex,
  Image,
  Input,
  VStack,
} from "@chakra-ui/react";
import i18next from "i18next";
import { useEffect, useState } from "react";
import logo from "@keita/lanepatrol-sdk/assets/logo/logo-vertical.png";

import { PublicScope } from "../../auth/models/PublicCredentials";
import { useStores } from "../../shared/stores/RootStore";

export const passwordParam = "public-password";
export const scopeIdParam = "public-scope-id";

interface Props {
  scope: PublicScope;
  scopeId: string;
  isInvalid: boolean;
  onSubmit: () => void;
}
export const AuthenticatorPage: React.FC<Props> = ({
  scope,
  scopeId,
  isInvalid,
  onSubmit,
}) => {
  const [password, setPassword] = useState("");
  const { mapStore } = useStores();

  useEffect(() => {
    function checkSessionStorageForCredentials() {
      const savedScopeId = window.sessionStorage.getItem(scopeIdParam);
      const savedPassword = window.sessionStorage.getItem(passwordParam);

      if (savedPassword && savedScopeId === scopeId) {
        mapStore.setCredentials({
          scope,
          scopeId,
          password: savedPassword,
        });
        onSubmit();
      }
    }

    checkSessionStorageForCredentials();
    // eslint-disable-next-line
  }, []);

  const handleSubmit = () => {
    window.sessionStorage.setItem(scopeIdParam, scopeId);
    window.sessionStorage.setItem(passwordParam, password);

    mapStore.setCredentials({ scope, scopeId, password });
    onSubmit();
  };

  return (
    <Flex alignItems="center" justifyContent="center" flexGrow={1}>
      <VStack>
        <Box mb={6} width="140px">
          <Image src={logo} alt="keita logo" />
        </Box>
        <form>
          <Field.Root invalid={isInvalid}>
            <Field.Label>{i18next.t("map:form.passwordLabel")}</Field.Label>
            <Input
              required
              type="password"
              value={password}
              autoComplete="off"
              onChange={(e) => {
                setPassword(e.target.value);
              }}
            />
            <Field.ErrorText>
              {i18next.t("map:form.invalidPassword")}
            </Field.ErrorText>
          </Field.Root>
        </form>
        <Button
          alignSelf="end"
          mt={2}
          colorPalette="primary"
          disabled={!password}
          onClick={handleSubmit}
        >
          {i18next.t("map:form.submitButton")}
        </Button>
      </VStack>
    </Flex>
  );
};
